import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../data/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // 1) Check localStorage first (user manual choice persists)
    const saved = localStorage.getItem('trattoria-lang');
    if (saved && ['it', 'de', 'fr', 'en'].includes(saved)) {
      return saved;
    }
    // 2) Auto-detect from browser/device language
    if (typeof navigator !== 'undefined') {
      const browserLangs = navigator.languages && navigator.languages.length
        ? navigator.languages
        : [navigator.language || navigator.userLanguage || ''];
      for (const l of browserLangs) {
        const code = (l || '').toLowerCase().slice(0, 2);
        if (['it', 'de', 'fr', 'en'].includes(code)) {
          return code;
        }
      }
    }
    // 3) Fallback to German (Swiss context)
    return 'de';
  });

  useEffect(() => {
    localStorage.setItem('trattoria-lang', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const changeLanguage = (lang) => {
    if (['it', 'de', 'fr', 'en'].includes(lang)) {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, t, changeLanguage, translations: translations[language] }}>
      {children}
    </LanguageContext.Provider>
  );
};
